export default "__VITE_ASSET__jSEsf5jy__"